import { Injectable } from '@angular/core';

import { AuthService, TokenService } from '@igo2/auth';

import { concat, defer, lastValueFrom, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import { ZzzConfigService } from '../core/config/config.service';
import { KeyPairs } from '../core/shared/core.models';
import { SecuriteConfigService } from './shared/securite-config.service';
import { ZzzSecuriteService } from './shared/securite.service';
import { SigtUtilisateurService } from 'src/app/shared/services/sigt-utilisateur.service';

@Injectable({
  providedIn: 'root'
})
export class SecuriteInitService {
  constructor(
    private configService: ZzzConfigService,
    private securiteConfigService: SecuriteConfigService,
    // private securiteTraductionService: SecuriteTraductionService,
    private securiteService: ZzzSecuriteService,
    private igoSecuriteService: AuthService,
    private tokenService: TokenService,
    private userService: SigtUtilisateurService
  ) {}

  init(): Promise<any> {
    var configInit = this.configService.onInit().pipe(
      tap((config) => {
        // this.securiteTraductionService.init();
        this.securiteConfigService.init(config);
      })
    );

    //On doit encapsuler appSecuriteService.init() dans un observable
    //puisqu'il utilise des configurations pour les urls qui ne sont pas
    //disponible lors de l'initalisation...
    var securiteInit = defer(() => this.securiteService.init()
      .pipe(
        switchMap(() => {
          if (!this.securiteService.isCallback && this.securiteService.utilisateurEstAuthentifie) {
            return this.userService.obtenirUtilisateurDetails().pipe(
              switchMap(rep => {
                if (rep == null) {
                  localStorage.setItem('SIGT-Error', this.userService.userError.error.messages[0].msg + '<br> Veuillez contacter l\'administrateur du site');
                  return this.securiteService.deconnecter();
                } else {
                  return of(null);
                }
              })
            );
          }

          return of(null);
        })
      )
    );

    return lastValueFrom(concat(configInit, securiteInit));
  }
}
